<div id="crm-partner-additional-salespeople-form" *ngIf="readOnly; else formField">
  <div class="crm-field-label">
    Additional salespeople
    <crm-sync-icon [fieldId]="_fieldId()"></crm-sync-icon>
  </div>
  <div class="crm-field-value">
    <ng-container *ngIf="selectedSalespeople() as salespeople; else loading">
      <ng-container *ngIf="salespeople !== NO_VALUE_FOR_SALESPERSON">
        <div class="salesperson">
          <div class="tags">
            <glxy-badge [glxyTooltip]="salespeopleNames().join(', ')">{{ salespeopleNames()[0] }}</glxy-badge>
            <glxy-badge *ngIf="salespeopleNames().length === 2" [glxyTooltip]="salespeopleNames().join(', ')">
              {{ salespeopleNames()[1] }}
            </glxy-badge>
            <glxy-badge *ngIf="salespeopleNames().length > 2" [glxyTooltip]="salespeopleNames().join(', ')">
              +{{ salespeopleNames().length - 1 }}
            </glxy-badge>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #loading>
      <div class="stencil-shimmer"></div>
    </ng-template>
  </div>
</div>
<ng-template #formField>
  <glxy-form-field>
    <glxy-label>
      Additional salespeople
      <crm-sync-icon [fieldId]="_fieldId()"></crm-sync-icon>
    </glxy-label>
    <mat-chip-grid [disabled]="loadingValues()" #salespersonGrid aria-label="Salesperson selection">
      <ng-container *ngIf="loadingValues(); else loadedChips">
        <mat-spinner [diameter]="24"></mat-spinner>
      </ng-container>
      <ng-template #loadedChips>
        <mat-chip-row
          *ngFor="let salesperson of selectedSalespeople()"
          (removed)="remove(salesperson.salespersonId); saveField()"
        >
          {{ salesperson.displayName }}
          <button matChipRemove [attr.aria-label]="'remove ' + salesperson.displayName">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      </ng-template>
      <input
        matInput
        #salespeopleInput
        [placeholder]="'Select...'"
        [formControl]="searchControl"
        [matChipInputFor]="salespersonGrid"
        [matAutocomplete]="auto"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="false"
        (matChipInputTokenEnd)="add($event)"
        (blur)="saveField()"
        data-testid="filter-additional-salespeople-input"
      />
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      <mat-option
        *ngFor="let option of filteredOptions()"
        [value]="option?.salespersonId"
        (mousedown)="$event.preventDefault()"
      >
        {{ option?.displayName }}
      </mat-option>
    </mat-autocomplete>
    @if (formGroup.errors?.additionalSalespeopleInSalesperson) {
      <glxy-error>
        {{ 'CRM.FORMS.SALESPERSON_IN_ADDITIONAL_SALESPEOPLE' | translate }}
      </glxy-error>
    }
    @if (_control.hasError('invalidSalesperson')) {
      <glxy-error>
        {{ 'CRM.FORMS.ONE_OF_THE_SELECTED_SALESPERSON_IN_ANOTHER_MARKET' | translate }}
      </glxy-error>
    }
  </glxy-form-field>
</ng-template>
